/* eslint-disable import/no-unresolved */
import 'javascripts/showroom_performance/index';
import 'stylesheets/showroom_performance/index';
